import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function HigherEducationList() {
  const [higherEducation, setHigherEducation] = useState([]);

  // Fetch higher education data from API
  const fetchHigherEducation = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/higherEducation`);
      setHigherEducation(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch higher education data.");
    }
  };

  useEffect(() => {
    fetchHigherEducation();
  }, []);

  return (
    <div className="container mx-auto px-4 py-10">
      <ToastContainer position="top-center" autoClose={3000} />

      {/* Banner Section with Image */}
      <div className="relative bg-gradient-to-r from-blue-600 via-teal-500 to-green-400 text-white text-center py-10 px-6 rounded-lg shadow-lg transform transition duration-500 hover:scale-105">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_RYwREMwAL9Zx1FG09lTPaKhSRgdfzvQIvgNTFO-99chohjJ8_UF_ZP8H8JQsYmL7a4M&usqp=CAU" // Replace this with the actual image path
          alt="Higher Education"
          className="absolute inset-0 w-full h-full object-cover opacity-30 rounded-lg"
        />
        <div className="relative z-10">
          <h1 className="text-3xl md:text-4xl font-bold">
            Higher Education Directory
          </h1>
          <p className="mt-4 text-lg font-medium">
            Explore and manage profiles of aspiring individuals pursuing higher
            education after completing their studies!
          </p>
        </div>
      </div>

      {/* Features Section */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Feature 1 */}
        <div className="bg-white shadow-lg rounded-lg p-6 border-t-4 border-teal-500 transform hover:scale-105 transition duration-500">
          <h2 className="text-xl font-semibold text-teal-600">
            Student Journey
          </h2>
          <p className="text-gray-700 mt-3">
            After completing their studies at our college, students can pursue a
            variety of higher education opportunities to expand their knowledge
            and skills. From master's programs to research opportunities, the
            sky's the limit!
          </p>
        </div>

        {/* Feature 2 */}
        <div className="bg-white shadow-lg rounded-lg p-6 border-t-4 border-blue-500 transform hover:scale-105 transition duration-500">
          <h2 className="text-xl font-semibold text-blue-600">How to Apply</h2>
          <p className="text-gray-700 mt-3">
            Submit your details via our online portal to create or manage your
            educational profile. We're here to help you take the next step in
            your education journey!
          </p>
        </div>

        {/* Feature 3 */}
        <div className="bg-white shadow-lg rounded-lg p-6 border-t-4 border-green-500 transform hover:scale-105 transition duration-500">
          <h2 className="text-xl font-semibold text-green-600">
            Support & Help
          </h2>
          <p className="text-gray-700 mt-3">
            For any queries, reach out to our support team at
            support@highereducation.com or call us at 1800-123-456. We're here
            to guide you through every step of the process.
          </p>
        </div>
      </div>

      {/* After Diploma Section */}
      <div className="mt-10 bg-white shadow-lg rounded-lg p-6 border-t-4 border-purple-500">
        <h2 className="text-2xl font-bold text-purple-600 mb-6 text-center">
          After Diploma: Career Opportunities
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Opportunity 1 */}
          <div className="bg-purple-50 rounded-lg p-5 shadow-md border-l-4 border-purple-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-purple-700">
              Lateral Entry to Bachelor's Programs
            </h3>
            <p className="text-gray-700 mt-2">
              Enter directly into the second year of a B.Tech or BCA program
              through lateral entry, saving a year of study while obtaining a
              more advanced qualification.
            </p>
          </div>

          {/* Opportunity 2 */}
          <div className="bg-blue-50 rounded-lg p-5 shadow-md border-l-4 border-blue-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-blue-700">
              IT Support & Technical Roles
            </h3>
            <p className="text-gray-700 mt-2">
              The combined knowledge of computer science and office management
              makes graduates ideal candidates for IT support positions and
              system administration.
            </p>
          </div>

          {/* Opportunity 3 */}
          <div className="bg-green-50 rounded-lg p-5 shadow-md border-l-4 border-green-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-green-700">
              Office Administration with Technical Expertise
            </h3>
            <p className="text-gray-700 mt-2">
              Your unique skill combination positions you perfectly for roles
              like technical office manager, IT operations coordinator, or
              administrative technology specialist.
            </p>
          </div>

          {/* Opportunity 4 */}
          <div className="bg-teal-50 rounded-lg p-5 shadow-md border-l-4 border-teal-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-teal-700">
              Software Development
            </h3>
            <p className="text-gray-700 mt-2">
              With CSE foundations, pursue entry-level software development, web
              development, or mobile application development with business
              operations understanding.
            </p>
          </div>

          {/* Opportunity 5 */}
          <div className="bg-indigo-50 rounded-lg p-5 shadow-md border-l-4 border-indigo-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-indigo-700">
              Database Administration
            </h3>
            <p className="text-gray-700 mt-2">
              Work with database systems, pursuing careers in database
              management and administration with understanding of how these
              systems support office operations.
            </p>
          </div>

          {/* Opportunity 6 */}
          <div className="bg-red-50 rounded-lg p-5 shadow-md border-l-4 border-red-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-red-700">
              Entrepreneurship Possibilities
            </h3>
            <p className="text-gray-700 mt-2">
              Your dual knowledge base provides a strong foundation to start a
              tech-focused business or offer technical support services to small
              and medium businesses.
            </p>
          </div>

          {/* Opportunity 7 */}
          <div className="bg-yellow-50 rounded-lg p-5 shadow-md border-l-4 border-yellow-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-yellow-700">
              Specialized Certification Pathways
            </h3>
            <p className="text-gray-700 mt-2">
              Pursue specialized certifications in network administration
              (CCNA), cloud computing (AWS, Azure), project management (CAPM),
              or office productivity suites.
            </p>
          </div>

          {/* Opportunity 8 */}
          <div className="bg-pink-50 rounded-lg p-5 shadow-md border-l-4 border-pink-400 hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold text-pink-700">
              Digital Transformation Roles
            </h3>
            <p className="text-gray-700 mt-2">
              Your combined knowledge makes you valuable for implementing
              digital transformation initiatives and optimizing office workflows
              through technology.
            </p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="#"
            className="inline-block bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-medium px-6 py-3 rounded-lg hover:from-purple-700 hover:to-indigo-700 transition duration-300 shadow-md"
          >
            Explore Career Guidance Programs
          </a>
        </div>
      </div>
    </div>
  );
}
